// @ts-ignore
/* eslint-disable */
import request from '../../utils/request';

/** 展示销售活码 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 GET /share-activity/contact-way/info */
export async function shareActivityContactWayInfoUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.shareActivityContactWayInfoUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultstring>('/share-activity/contact-way/info', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 获取活动信息 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 GET /share-activity/info */
export async function shareActivityInfoUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.shareActivityInfoUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultShareActivityInfoResp>('/share-activity/info', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 获取活动邀请信息 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 GET /share-activity/invite-info */
export async function shareActivityInviteInfoUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.shareActivityInviteInfoUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultStartInviteShareActivityResp>('/share-activity/invite-info', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 获取活动邀请列表 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 GET /share-activity/invite-list */
export async function shareActivityInviteListUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.shareActivityInviteListUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultListShareActivityInviteInfoResp>('/share-activity/invite-list', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 邀请活动开始 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 POST /share-activity/invite-start */
export async function shareActivityInviteStartUsingPOST(
  body: API.StartShareActivityInviteReq,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultVoid>('/share-activity/invite-start', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 获取最近已领取列表 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 GET /share-activity/latest-receive-list */
export async function shareActivityLatestReceiveListUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.shareActivityLatestReceiveListUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultListShareActivityReceiveInfoResp>(
    '/share-activity/latest-receive-list',
    {
      method: 'GET',
      params: {
        ...params,
      },
      ...(options || {}),
    },
  );
}

/** 获取活动奖励列表 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 GET /share-activity/reward-list */
export async function shareActivityRewardListUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.shareActivityRewardListUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultListShareActivityInviteRewardResp>('/share-activity/reward-list', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}
